/* eslint-disable no-nested-ternary */
import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';

import { useBreadcrumbs, useSeoMeta, useSelectorProps } from 'hooks';
import {
  getLocaleUrlPath,
  DEFAULT_SEO_DATE_FORMAT,
  formatParsedDate,
} from 'utils';

import BreadCrumbs from 'components/BreadCrumbs';

export const NbuPageBreadCrumbs = () => {
  const selectorProps = useSelectorProps();
  const location = useLocation();
  const { pageTitle } = useSeoMeta();
  const { locale, formatMessage } = useIntl();
  const { date, currency } = useParams();

  const curr = useSelector(state => {
    if (currency) {
      return state.currency.currencyList.filter(
        el => el.name.toLowerCase() === currency.toLowerCase()
      );
    }

    return '';
  });

  const localeInURL = getLocaleUrlPath(locale);
  const routerBasename = `${localeInURL}${process.env.APP_ROUTER_BASENAME}`;

  const breadcrumbsPlaceholders = useMemo(
    () => [
      {
        name: formatMessage({ id: 'breadcrumbs.mainPage' }),
        link: getLocaleUrlPath(locale),
      },
      {
        name: formatMessage({ id: 'breadcrumbs.currencyPage' }),
        link: routerBasename,
      },
      ...(currency && !date
        ? [
            {
              name: formatMessage({ id: 'breadcrumbs.nbuPage' }),
              link: `${routerBasename}${location.pathname}`,
            },
            {
              name: pageTitle,
              link: `${routerBasename}${location.pathname}`,
            },
          ]
        : date && !currency
        ? [
            {
              name: formatMessage({ id: 'breadcrumbs.nbuPage' }),
              link: `${routerBasename}${location.pathname}`,
            },
            {
              name: pageTitle,
              link: `${routerBasename}${location.pathname}`,
            },
          ]
        : date && currency
        ? [
            {
              name: formatMessage({ id: 'breadcrumbs.nbuPage' }),
              link: `${routerBasename}${location.pathname}`,
            },
            {
              name: formatMessage(
                {
                  id: `nbuPage.pageTitle.withCurrency`,
                },
                {
                  currency: curr[0]?.nameG || curr[0]?.text,
                  date:
                    formatParsedDate(
                      date,
                      DEFAULT_SEO_DATE_FORMAT,
                      selectorProps.intl.locale
                    ) || '',
                }
              ),
              link: `${routerBasename}/nbu/${currency}/`,
            },
            {
              name: pageTitle,
              link: `${routerBasename}${location.pathname}`,
            },
          ]
        : [
            {
              name: formatMessage({ id: 'breadcrumbs.nbuPage' }),
              link: `${routerBasename}${location.pathname}`,
            },
          ]),
    ],
    [location, date, currency]
  );

  const breadcrumbs = useBreadcrumbs(breadcrumbsPlaceholders);

  return breadcrumbs.length ? <BreadCrumbs breadcrumbs={breadcrumbs} /> : null;
};

export default memo(NbuPageBreadCrumbs);
